var map = {
	"./body_01.png": 6566,
	"./body_02.png": 4894,
	"./body_03.png": 506,
	"./body_04.png": 7650,
	"./body_05.png": 6014,
	"./body_06.png": 2385,
	"./body_07.png": 2483,
	"./body_08.png": 7421,
	"./body_09.png": 4,
	"./body_10.png": 6062,
	"./body_11.png": 1006,
	"./body_12.png": 5554,
	"./body_13.png": 9154,
	"./body_14.png": 3316,
	"./body_15.png": 2018,
	"./body_16.png": 8020,
	"./body_17.png": 9782,
	"./body_18.png": 5182,
	"./body_19.png": 2922,
	"./body_20.png": 1526,
	"./body_21.png": 4652,
	"./body_22.png": 1576,
	"./body_23.png": 6154,
	"./body_24.png": 2108,
	"./body_25.png": 2192,
	"./body_26.png": 6418,
	"./body_27.png": 287,
	"./body_28.png": 5608,
	"./body_29.png": 3564,
	"./body_30.png": 1518,
	"./body_31.png": 6033,
	"./body_32.png": 9035,
	"./body_33.png": 1358,
	"./body_34.png": 6897,
	"./body_35.png": 5478,
	"./body_36.png": 8626,
	"./body_37.png": 6696,
	"./body_38.png": 4334,
	"./body_39.png": 4369,
	"./body_40.png": 5645,
	"./body_41.png": 6267,
	"./body_42.png": 1474,
	"./body_43.png": 3132,
	"./body_44.png": 9637,
	"./body_45.png": 2851,
	"./body_46.png": 7433,
	"./body_47.png": 2670,
	"./body_NA.png": 9013,
	"./body_yellow.png": 229
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6717;